import {Component, Input} from '@angular/core'
import { DeliveryMode } from '@spartacus/cart/base/root'
import {Address, CmsOrderDetailOverviewComponent, TranslationService} from '@spartacus/core'
import {OrderDetailsService, OrderOverviewComponent} from '@spartacus/order/components'
import {Card, CmsComponentData} from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { EbCardConstructorService } from '../../../../services/eb-card-constructor.service'

@Component({
    selector: 'eb-order-overview',
    templateUrl: './eb-order-overview.component.html',
    styleUrls: ['../../../review-submit/eb-review-submit.component.scss'],
    standalone: false
})
export class EbOrderOverview extends OrderOverviewComponent{
  @Input() selectedDeliveryMode: DeliveryMode
  @Input() order$: any

  constructor(
    protected translation: TranslationService,
    protected cardConstructor: EbCardConstructorService,
    protected orderDetailsService: OrderDetailsService,
    protected component: CmsComponentData<CmsOrderDetailOverviewComponent>,
  ) {
    super(translation, orderDetailsService, component)
  }
  getAddressCardContent(deliveryAddress: Address): Observable<Card> {
    return this.cardConstructor.getShippingAddressCard(deliveryAddress)
  }

  getOrderCodeCardContent(orderCode: string): Observable<Card> {
    return this.cardConstructor.getOrderCodeCardContent(orderCode)
  }

  getOrderCurrentDateCardContent(isoDate: string): Observable<Card> {
    return this.cardConstructor.getOrderCurrentDateCardContent(isoDate)
  }

  getOrderShippingDateCardContent(isoDate?: string): Observable<Card> {
    return this.cardConstructor.getOrderShippingDateCardContent(isoDate)
  }

  getOrderStatusCardContent(status: string, statusCode?: string): Observable<Card> {
    return this.cardConstructor.getOrderStatusCardContent(status, statusCode)
  }

  getInvoiceAddressCard(invoiceAddress: Address): Observable<Card> {
    return this.cardConstructor.getInvoiceAddressCard(invoiceAddress)
  }

  getPoNumberCard(poNumber: string): Observable<Card> {
    return this.cardConstructor.getPoNumberCard(poNumber)
  }

  getPaymentTypeCard(): Observable<Card> {
    return this.cardConstructor.getPaymentTypeCard()
  }

  getDeliveryModeCard(
    deliveryMode: DeliveryMode,
    shippingDate: string,
    completeDelivery: boolean,
    loading?: boolean
  ): Observable<Card> {
    return this.cardConstructor.getDeliveryCard(
      deliveryMode,
      shippingDate,
      completeDelivery,
      loading
    )
  }

  getOrderedByCard(name: string): Observable<Card> {
    return this.cardConstructor.getOrderedByCard(name)
  }
}
